import { IconButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
const UnauthorizedPage = () => {
  const navigate = useNavigate();
  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-gray-100'>
      <IconButton className='bg-red-200 '>
        <LockIcon className='text-red-500 size-24 m-2' />
      </IconButton>
      <h1 className='text-6xl font-bold text-gray-800 mb-4'>401</h1>
      <h1 className='text-2xl font-bold text-gray-800 mb-4'>
        UnAuthorized Access
      </h1>

      <p className='text-xl text-gray-600 mb-8'>
        You are not an authorized user to access the page you want to access
      </p>
      <button
        onClick={() => navigate('/signin')}
        className='px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors'
      >
        Go Back / Login
      </button>
    </div>
  );
};

export default UnauthorizedPage;
